module.exports = __webpack_public_path__ + "img/agro-bank-img.9838de51.png";